import { render, staticRenderFns } from "./RinvRL2.vue?vue&type=template&id=4959c32c"
import script from "./RinvRL2.vue?vue&type=script&lang=js"
export * from "./RinvRL2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports